'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Editable = require('apollo-cms/lib/DataView/Object/Editable');

var _Editable2 = _interopRequireDefault(_Editable);

var _withStyles = require('material-ui/styles/withStyles');

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = function styles(theme) {
  return {
    root: {},
    table: {
      borderCollapse: "collapse",
      width: "100%",
      "& th, td": {
        textAlign: "left",
        verticalAlign: "center",
        padding: "5px 10px",
        border: "1px solid #ddd"
      }
    }
  };
};

var TransactionView = function (_EditableView) {
  _inherits(TransactionView, _EditableView);

  function TransactionView() {
    var _temp, _this, _ret;

    _classCallCheck(this, TransactionView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _EditableView.call.apply(_EditableView, [this].concat(args))), _this), _this.state = _extends({}, _EditableView.prototype.state, {
      showPasswordField: false,
      password: "",
      isDeploying: false
    }), _temp), _possibleConstructorReturn(_this, _ret);
  } // static propTypes = {
  //   ...EditableView.propTypes,
  //   classes: PropTypes.object.isRequired,
  // };
  // static defaultProps = {
  //   ...EditableView.defaultProps,
  // };


  TransactionView.prototype.canEdit = function canEdit() {
    return false;
  }; // save() {
  //   const {
  //     user: currentUser,
  //     openLoginForm,
  //   } = this.context;
  //   if (!currentUser) {
  //     return openLoginForm();
  //   }
  //   return super.save();
  // }
  // getCacheKey() {
  //   const {
  //     id,
  //   } = this.getObject() || {};
  //   return `transaction_${id || "new"}`;
  // }
  // getTitle(){
  //   const {
  //     address,
  //   } = this.getObjectWithMutations() || {};
  //   return address && [...address] || null;
  // }


  TransactionView.prototype.renderHeader = function renderHeader() {
    return null;
  };

  TransactionView.prototype.renderDefaultView = function renderDefaultView() {
    var classes = this.props.classes;
    var object = this.getObjectWithMutations();

    if (!object) {
      return null;
    }

    var _context = this.context,
        UserLink = _context.UserLink,
        Grid = _context.Grid;
    var transactionId = object.id,
        address = object.address,
        type = object.type,
        amount = object.amount,
        Sender = object.Sender,
        Receiver = object.Receiver;

    var _ref = Sender || {},
        SenderUser = _ref.CreatedBy;

    var _ref2 = Receiver || {},
        ReceiverUser = _ref2.CreatedBy;

    var inEditMode = this.isInEditMode();
    var canEdit = this.canEdit();
    var transactionType = type;

    switch (type) {
      case "SendEth":
        transactionType = "Перевод эфира";
        break;

      case "ContractCreate":
        transactionType = "Создание контракта";
        break;
    }

    return _react2.default.createElement(Grid, {
      container: true,
      spacing: 8
    }, _react2.default.createElement(Grid, {
      item: true,
      xs: 12
    }, _react2.default.createElement('table', {
      className: classes.table
    }, _react2.default.createElement('tbody', null, _react2.default.createElement('tr', null, _react2.default.createElement('th', null, "\u0410\u0434\u0440\u0435\u0441 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438"), _react2.default.createElement('td', null, _react2.default.createElement('a', {
      href: 'https://etherscan.io/tx/' + address,
      target: '_blank',
      rel: 'nowollow'
    }, address))), _react2.default.createElement('tr', null, _react2.default.createElement('th', null, "\u0422\u0438\u043F \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438"), _react2.default.createElement('td', null, transactionType)), amount ? _react2.default.createElement('tr', null, _react2.default.createElement('th', null, "\u0421\u0443\u043C\u043C\u0430"), _react2.default.createElement('td', null, amount)) : null, SenderUser ? _react2.default.createElement('tr', null, _react2.default.createElement('th', null, "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u0435\u043B\u044C"), _react2.default.createElement('td', null, _react2.default.createElement(UserLink, {
      user: SenderUser
    }))) : null, ReceiverUser ? _react2.default.createElement('tr', null, _react2.default.createElement('th', null, "\u041F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044C"), _react2.default.createElement('td', null, _react2.default.createElement(UserLink, {
      user: ReceiverUser
    }))) : null))));
  };

  TransactionView.prototype.renderEditableView = function renderEditableView() {
    return this.renderDefaultView();
  };

  TransactionView.prototype.render = function render() {
    var object = this.getObjectWithMutations();

    if (!object) {
      return null;
    }

    var classes = this.props.classes;
    return _react2.default.createElement('div', {
      className: classes.root
    }, _EditableView.prototype.render.call(this));
  };

  return TransactionView;
}(_Editable2.default);

exports.default = (0, _withStyles2.default)(styles)(function (props) {
  return _react2.default.createElement(TransactionView, props);
});
module.exports = exports['default'];